import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  Modal,
  DropdownButton,
  MenuItem,
  ButtonGroup
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  get_question_list,
  delete_question
} from "../../../redux/actions/questionActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import loader from "../../../style/loader/loader.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class QuestionList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MANAGE_QUESTIONS',
      questionList: [],
      totalRecords: 0,
      perPage: 0,
      limit:25,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "Questions"],
      links: ["home",'questions'],
      show: false,
      dealTextSortIcon: "",
      merchantFirstNameSortIcon: "",
      firstNameSortIcon: "",
      created_onSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      faq: "",
      showModal: false,
      question: "",
      name: "",
      deal: "",
      weightSortIcon: "",
      created_onSortIcon: ""
    };
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_question_list({
      page: this.state.currentPage,
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.get_question_list({ page: this.state.currentPage,limit: this.state.limit });
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_question_list({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.get_question_list({
        page: page,
        search: this.state.searchString,
        limit: this.state.limit
      });
    } else {
      this.props.get_question_list({ page: page,limit: this.state.limit });
    }
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_question_list({
        search: searchString,
        page: this.state.currentPage,
        limit: this.state.limit
      });
    } else {
      this.props.get_question_list({ page: this.state.currentPage,limit: this.state.limit });
    }
    this.setState({ searchString: searchString });
  };

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (
      this.props.questionList !== nextProps.questionList &&
      !isEmpty(nextProps.questionList)
    ) {
      if (nextProps.questionList.data) {
        const setPageCount =
          nextProps.questionList.total / nextProps.questionList.per_page;
        this.setState({
          questionList: nextProps.questionList.data,
          totalRecords: nextProps.questionList.total,
          perPage: nextProps.questionList.per_page,
          pageCount: setPageCount
        });
      }
    }
    if (this.props.deletedQuestion !== nextProps.deletedQuestion) {
      if (nextProps.deletedQuestion) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deletedQuestion.message);
        this.handlePageChange(this.state.currentPage);
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
    }
    if (nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }
  }

  handleView = (question, dealText, firstName, lastName) => {
    const userName = `${firstName} ${lastName}`;
    this.setState({
      question: question,
      name: userName,
      showModal: true,
      deal: dealText
    });
  };

  handleDelete = quesID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(quesID);
        })
      ]
    });
  };

  confirmDelete = quesID => {
    this.props.delete_question(quesID);
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let questionRow;
    if (
      !isEmpty(this.props.questionList) &&
      this.props.questionList.data.length > 0
    ) {
      questionRow = this.props.questionList.data.map((question, index) => (
        <tr key={question.quesID}>
          <td>{question.created_on}</td>
          <td>{question.dealText}</td>
          <td style={{ textTransform: "capitalize" }}>{`${
            question.merchantFirstName
          } ${question.merchantLastName}`}</td>
          <td style={{ textTransform: "capitalize" }}>{`${question.firstName} ${
            question.lastName
          }`}</td>
          <td>
            {question.question.length > 30
              ? `${question.question.charAt(0).toUpperCase() +
                  question.question.substr(1).substr(0, 30)}...`
              : question.question.charAt(0).toUpperCase() +
                question.question.substr(1)}
          </td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('VIEW_QUESTION') ? (<MenuItem eventKey={Math.random()} onClick={this.handleView.bind(
                            this,
                            question.question,
                            question.dealText,
                            question.firstName,
                            question.lastName
                          )}><i className="glyphicon glyphicon-eye-open"></i> View</MenuItem>):("")}
                  {aclUtil.checkACL('GIVE_ANSWER') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/giveAnswer/${question.quesID}`)}><i className="glyphicon glyphicon-pencil"></i> Give Answer</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_QUESTION') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, question.quesID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 faq-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Questions</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType.toLowerCase()}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("created_on")}>
                        Created On<span
                          className={this.state.created_onSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("dealText")}>
                        Deal<span
                          className={this.state.dealTextSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("merchantFirstName")}>
                        Merchant Name<span
                          className={this.state.merchantFirstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("firstName")}>
                        User Name<span
                          className={this.state.firstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Question</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{questionRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title
              style={{ textTransform: "capitalize", fontWeight: "bold" }}
            >
              {this.state.deal}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                User Name:{" "}
              </span>{" "}
              <span style={{ fontSize: "15px", textTransform: "capitalize" }}>
                {this.state.name}
              </span>
            </div>
            <div>
              <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                Question:{" "}
              </span>
            </div>
            <p>
              {this.state.question.charAt(0).toUpperCase() +
                this.state.question.substr(1)}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

QuestionList.propTypes = {
  get_question_list: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  questionList: state.questionReducer.questionList,
  error: state.questionReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  deletedQuestion: state.questionReducer.deletedQuestion,
  receivingQuestion: state.questionReducer.receivingQuestion
});

export default withRouter(connect(mapStateToProps, {
  delete_question,
  get_question_list,
  renderAlert,
  clearAlert
})(QuestionList));



// WEBPACK FOOTER //
// ./src/app/views/admin/question/QuestionList.js